// This file is auto-generated by running bin/generate-bindings.
// DO NOT EDIT THIS FILE OR DO NOT UPDATE THIS FILE IN ANY OTHER WAY THAN BY RUNNING bin/generate-bindings.
//
// Since this file is auto-generated, any changes you make to it will be overwritten by the next run of bin/generate-bindings.

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client"
import { client } from "./client.generated"
import type {
  AcknowledgeAiUsageNoticeData,
  AcknowledgeAiUsageNoticeResponses,
  AllUserConversationsData,
  AllUserConversationsResponses,
  ClaimCodeFromCodeGiveawayData,
  ClaimCodeFromCodeGiveawayResponses,
  DeleteCourseMaterialGlossaryTermData,
  DeleteCourseMaterialGlossaryTermResponses,
  EndExamTimeData,
  EndExamTimeResponses,
  EnrollInExamData,
  EnrollInExamResponses,
  FetchExamData,
  FetchExamEnrollmentData,
  FetchExamEnrollmentResponses,
  FetchExamForTestingData,
  FetchExamForTestingResponses,
  FetchExamResponses,
  FetchPeerOrSelfReviewDataByExerciseIdData,
  FetchPeerOrSelfReviewDataByExerciseIdResponses,
  FetchPeerReviewDataReceivedByExerciseIdData,
  FetchPeerReviewDataReceivedByExerciseIdResponses,
  GetAiUsageNoticeAcknowledgementData,
  GetAiUsageNoticeAcknowledgementResponses,
  GetCodeGiveawayStatusData,
  GetCodeGiveawayStatusResponses,
  GetConversationInfoData,
  GetConversationInfoResponses,
  GetCourseMaterialAuthenticatedUserDetailsData,
  GetCourseMaterialAuthenticatedUserDetailsResponses,
  GetCourseMaterialBackgroundQuestionsAndAnswersData,
  GetCourseMaterialBackgroundQuestionsAndAnswersResponses,
  GetCourseMaterialChapterExerciseProgressData,
  GetCourseMaterialChapterExerciseProgressResponses,
  GetCourseMaterialChapterFrontPageData,
  GetCourseMaterialChapterFrontPageResponses,
  GetCourseMaterialChapterLockPreviewData,
  GetCourseMaterialChapterLockPreviewResponses,
  GetCourseMaterialChapterPagesData,
  GetCourseMaterialChapterPagesExcludingFrontPageData,
  GetCourseMaterialChapterPagesExcludingFrontPageResponses,
  GetCourseMaterialChapterPagesResponses,
  GetCourseMaterialChapterPagesWithExercisesData,
  GetCourseMaterialChapterPagesWithExercisesResponses,
  GetCourseMaterialChapterProgressData,
  GetCourseMaterialChapterProgressResponses,
  GetCourseMaterialChaptersData,
  GetCourseMaterialChaptersResponses,
  GetCourseMaterialCountryFromIpData,
  GetCourseMaterialCountryFromIpResponses,
  GetCourseMaterialCourseData,
  GetCourseMaterialCourseInstancesData,
  GetCourseMaterialCourseInstancesResponses,
  GetCourseMaterialCourseModuleCompletionsForUserData,
  GetCourseMaterialCourseModuleCompletionsForUserResponses,
  GetCourseMaterialCourseModulePointsBreakdownData,
  GetCourseMaterialCourseModulePointsBreakdownResponses,
  GetCourseMaterialCoursePageByPathData,
  GetCourseMaterialCoursePageByPathResponses,
  GetCourseMaterialCoursePagesData,
  GetCourseMaterialCoursePagesResponses,
  GetCourseMaterialCourseResponses,
  GetCourseMaterialCustomPrivacyPolicyCheckboxTextsData,
  GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponses,
  GetCourseMaterialDefaultModuleIdByCourseIdData,
  GetCourseMaterialDefaultModuleIdByCourseIdResponses,
  GetCourseMaterialExerciseData,
  GetCourseMaterialExerciseResponses,
  GetCourseMaterialExerciseTasksByModuleAndTypeData,
  GetCourseMaterialExerciseTasksByModuleAndTypeResponses,
  GetCourseMaterialGlossaryData,
  GetCourseMaterialGlossaryResponses,
  GetCourseMaterialIsPageChapterFrontPageData,
  GetCourseMaterialIsPageChapterFrontPageResponses,
  GetCourseMaterialLanguageVersionNavigationInfosData,
  GetCourseMaterialLanguageVersionNavigationInfosResponses,
  GetCourseMaterialMentimeterOembedData,
  GetCourseMaterialMentimeterOembedResponses,
  GetCourseMaterialModuleIdByChapterIdData,
  GetCourseMaterialModuleIdByChapterIdResponses,
  GetCourseMaterialOrganizationData,
  GetCourseMaterialOrganizationResponses,
  GetCourseMaterialPageAudioFilesData,
  GetCourseMaterialPageAudioFilesResponses,
  GetCourseMaterialPageByCourseIdAndLanguageGroupIdData,
  GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponses,
  GetCourseMaterialPageByExamIdData,
  GetCourseMaterialPageByExamIdResponses,
  GetCourseMaterialPageChapterAndCourseInformationData,
  GetCourseMaterialPageChapterAndCourseInformationResponses,
  GetCourseMaterialPageNavigationData,
  GetCourseMaterialPageNavigationResponses,
  GetCourseMaterialPageUrlPathData,
  GetCourseMaterialPageUrlPathResponses,
  GetCourseMaterialPartnersBlockData,
  GetCourseMaterialPartnersBlockResponses,
  GetCourseMaterialPrivacyLinkData,
  GetCourseMaterialPrivacyLinkResponses,
  GetCourseMaterialReferencesData,
  GetCourseMaterialReferencesResponses,
  GetCourseMaterialResearchConsentFormAnswersData,
  GetCourseMaterialResearchConsentFormAnswersResponses,
  GetCourseMaterialResearchConsentFormData,
  GetCourseMaterialResearchConsentFormQuestionsData,
  GetCourseMaterialResearchConsentFormQuestionsResponses,
  GetCourseMaterialResearchConsentFormResponses,
  GetCourseMaterialStudentCountriesData,
  GetCourseMaterialStudentCountriesResponses,
  GetCourseMaterialStudentCountryData,
  GetCourseMaterialStudentCountryResponses,
  GetCourseMaterialTopLevelPagesData,
  GetCourseMaterialTopLevelPagesResponses,
  GetCourseMaterialUserChapterLocksData,
  GetCourseMaterialUserChapterLocksResponses,
  GetCourseMaterialUserCourseProgressData,
  GetCourseMaterialUserCourseProgressResponses,
  GetCourseMaterialUserCourseSettingsData,
  GetCourseMaterialUserCourseSettingsResponses,
  GetCourseMaterialUserMarketingConsentData,
  GetCourseMaterialUserMarketingConsentResponses,
  GetCourseMaterialUserModuleCompletionsData,
  GetCourseMaterialUserModuleCompletionsResponses,
  GetCurrentConversationIdData,
  GetCurrentConversationIdResponses,
  GetCurrentCourseMaterialCourseInstanceData,
  GetCurrentCourseMaterialCourseInstanceResponses,
  GetDefaultChatbotConfigurationForCourseData,
  GetDefaultChatbotConfigurationForCourseResponses,
  LockCourseMaterialChapterData,
  LockCourseMaterialChapterResponses,
  NewChatbotConversationData,
  NewChatbotConversationResponses,
  PostCourseMaterialCourseEditProposalData,
  PostCourseMaterialCourseEditProposalResponses,
  PostCourseMaterialProposedEditsData,
  PostCourseMaterialProposedEditsResponses,
  PostCourseMaterialResearchConsentFormAnswerData,
  PostCourseMaterialResearchConsentFormAnswerResponses,
  PostCourseMaterialStudentCountryData,
  PostCourseMaterialStudentCountryResponses,
  PostFeedbackData,
  PostFeedbackResponses,
  PostFlagAnswerInPeerReviewData,
  PostFlagAnswerInPeerReviewResponses,
  PostPeerOrSelfReviewSubmissionData,
  PostPeerOrSelfReviewSubmissionResponses,
  PostStartPeerOrSelfReviewData,
  PostStartPeerOrSelfReviewResponses,
  PostSubmissionData,
  PostSubmissionResponses,
  ResetExamProgressData,
  ResetExamProgressResponses,
  SaveCourseMaterialCourseSettingsData,
  SaveCourseMaterialCourseSettingsResponses,
  SearchPagesWithPhraseData,
  SearchPagesWithPhraseResponses,
  SearchPagesWithWordsData,
  SearchPagesWithWordsResponses,
  SendChatbotMessageData,
  SendChatbotMessageResponses,
  SendChatbotToolResponseData,
  SendChatbotToolResponseResponses,
  UpdateCourseMaterialGlossaryTermData,
  UpdateCourseMaterialGlossaryTermResponses,
  UpdateCourseMaterialUserInfoData,
  UpdateCourseMaterialUserInfoResponses,
  UpdateMarketingConsentData,
  UpdateMarketingConsentResponses,
  UpdateShowExerciseAnswersData,
  UpdateShowExerciseAnswersResponses,
  UpdateTitleData,
  UpdateTitleResponses,
} from "./types.generated"
import {
  zAcknowledgeAiUsageNoticeResponse,
  zAllUserConversationsResponse,
  zClaimCodeFromCodeGiveawayResponse,
  zFetchExamEnrollmentResponse,
  zFetchExamForTestingResponse,
  zFetchExamResponse,
  zFetchPeerOrSelfReviewDataByExerciseIdResponse,
  zFetchPeerReviewDataReceivedByExerciseIdResponse,
  zGetAiUsageNoticeAcknowledgementResponse,
  zGetCodeGiveawayStatusResponse,
  zGetConversationInfoResponse,
  zGetCourseMaterialAuthenticatedUserDetailsResponse,
  zGetCourseMaterialBackgroundQuestionsAndAnswersResponse,
  zGetCourseMaterialChapterExerciseProgressResponse,
  zGetCourseMaterialChapterFrontPageResponse,
  zGetCourseMaterialChapterLockPreviewResponse,
  zGetCourseMaterialChapterPagesExcludingFrontPageResponse,
  zGetCourseMaterialChapterPagesResponse,
  zGetCourseMaterialChapterPagesWithExercisesResponse,
  zGetCourseMaterialChapterProgressResponse,
  zGetCourseMaterialChaptersResponse,
  zGetCourseMaterialCountryFromIpResponse,
  zGetCourseMaterialCourseInstancesResponse,
  zGetCourseMaterialCourseModuleCompletionsForUserResponse,
  zGetCourseMaterialCourseModulePointsBreakdownResponse,
  zGetCourseMaterialCoursePageByPathResponse,
  zGetCourseMaterialCoursePagesResponse,
  zGetCourseMaterialCourseResponse,
  zGetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponse,
  zGetCourseMaterialDefaultModuleIdByCourseIdResponse,
  zGetCourseMaterialExerciseResponse,
  zGetCourseMaterialExerciseTasksByModuleAndTypeResponse,
  zGetCourseMaterialGlossaryResponse,
  zGetCourseMaterialIsPageChapterFrontPageResponse,
  zGetCourseMaterialLanguageVersionNavigationInfosResponse,
  zGetCourseMaterialMentimeterOembedResponse,
  zGetCourseMaterialModuleIdByChapterIdResponse,
  zGetCourseMaterialOrganizationResponse,
  zGetCourseMaterialPageAudioFilesResponse,
  zGetCourseMaterialPageByCourseIdAndLanguageGroupIdResponse,
  zGetCourseMaterialPageByExamIdResponse,
  zGetCourseMaterialPageChapterAndCourseInformationResponse,
  zGetCourseMaterialPageNavigationResponse,
  zGetCourseMaterialPageUrlPathResponse,
  zGetCourseMaterialPartnersBlockResponse,
  zGetCourseMaterialPrivacyLinkResponse,
  zGetCourseMaterialReferencesResponse,
  zGetCourseMaterialResearchConsentFormAnswersResponse,
  zGetCourseMaterialResearchConsentFormQuestionsResponse,
  zGetCourseMaterialResearchConsentFormResponse,
  zGetCourseMaterialStudentCountriesResponse,
  zGetCourseMaterialStudentCountryResponse,
  zGetCourseMaterialTopLevelPagesResponse,
  zGetCourseMaterialUserChapterLocksResponse,
  zGetCourseMaterialUserCourseProgressResponse,
  zGetCourseMaterialUserCourseSettingsResponse,
  zGetCourseMaterialUserMarketingConsentResponse,
  zGetCourseMaterialUserModuleCompletionsResponse,
  zGetCurrentConversationIdResponse,
  zGetCurrentCourseMaterialCourseInstanceResponse,
  zGetDefaultChatbotConfigurationForCourseResponse,
  zLockCourseMaterialChapterResponse,
  zNewChatbotConversationResponse,
  zPostCourseMaterialCourseEditProposalResponse,
  zPostCourseMaterialResearchConsentFormAnswerResponse,
  zPostCourseMaterialStudentCountryResponse,
  zPostFeedbackResponse,
  zPostFlagAnswerInPeerReviewResponse,
  zPostPeerOrSelfReviewSubmissionResponse,
  zPostStartPeerOrSelfReviewResponse,
  zPostSubmissionResponse,
  zSaveCourseMaterialCourseSettingsResponse,
  zSearchPagesWithPhraseResponse,
  zSearchPagesWithWordsResponse,
  zSendChatbotMessageResponse,
  zSendChatbotToolResponseResponse,
  zUpdateCourseMaterialUserInfoResponse,
  zUpdateMarketingConsentResponse,
} from "./zod.generated"

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

export const deleteCourseMaterialGlossaryTerm = <ThrowOnError extends boolean = true>(
  options: Options<DeleteCourseMaterialGlossaryTermData, ThrowOnError>,
): RequestResult<DeleteCourseMaterialGlossaryTermResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).delete<
    DeleteCourseMaterialGlossaryTermResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseStyle: "data",
    url: "/api/v0/course-material/acronyms/{id}/delete",
    ...options,
  })

export const updateCourseMaterialGlossaryTerm = <ThrowOnError extends boolean = true>(
  options: Options<UpdateCourseMaterialGlossaryTermData, ThrowOnError>,
): RequestResult<UpdateCourseMaterialGlossaryTermResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).put<
    UpdateCourseMaterialGlossaryTermResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseStyle: "data",
    url: "/api/v0/course-material/acronyms/{id}/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/exercises` - Returns a list of pages and its exercises in chapter.
 */
export const getCourseMaterialChapterPagesWithExercises = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterPagesWithExercisesData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialChapterPagesWithExercisesResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterPagesWithExercisesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterPagesWithExercisesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chapters/{chapter_id}/exercises",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/chapters/:chapter_id/lock` - Complete chapter (mark as done)
 *
 * Completes a chapter for the authenticated user (marks it as done).
 *
 * Validates that:
 * - Course has chapter_locking_enabled
 * - Chapter is currently unlocked (student can work on it)
 * - All previous chapters in the same module are completed (sequential completion)
 * - Moves all exercises to manual review
 * - Unlocks next chapters for the user
 * *
 */
export const lockCourseMaterialChapter = <ThrowOnError extends boolean = true>(
  options: Options<LockCourseMaterialChapterData, ThrowOnError>,
): RequestResult<LockCourseMaterialChapterResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    LockCourseMaterialChapterResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zLockCourseMaterialChapterResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chapters/{chapter_id}/lock",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/lock-preview` - Preview lock chapter
 *
 * Returns information about unreturned exercises in the chapter before locking.
 * *
 */
export const getCourseMaterialChapterLockPreview = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterLockPreviewData, ThrowOnError>,
): RequestResult<GetCourseMaterialChapterLockPreviewResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterLockPreviewResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterLockPreviewResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chapters/{chapter_id}/lock-preview",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/pages` - Returns a list of pages in chapter.
 */
export const getCourseMaterialChapterPages = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterPagesData, ThrowOnError>,
): RequestResult<GetCourseMaterialChapterPagesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterPagesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterPagesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chapters/{chapter_id}/pages",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/pages-exclude-mainfrontpage` - Returns a list of pages in chapter mainfrontpage excluded.
 */
export const getCourseMaterialChapterPagesExcludingFrontPage = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialChapterPagesExcludingFrontPageData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialChapterPagesExcludingFrontPageResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterPagesExcludingFrontPageResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterPagesExcludingFrontPageResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chapters/{chapter_id}/pages-exclude-mainfrontpage",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chatbot/conversations/all`
 *
 * Returns all conversations that a user has.
 */
export const allUserConversations = <ThrowOnError extends boolean = true>(
  options?: Options<AllUserConversationsData, ThrowOnError>,
): RequestResult<AllUserConversationsResponses, unknown, ThrowOnError, "data"> =>
  (options?.client ?? client).get<AllUserConversationsResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zAllUserConversationsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/conversations/all",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-modules/chatbot/default-for-course/:course-id`
 *
 * Returns the default chatbot configuration id for a course if the default chatbot is enabled to students.
 */
export const getDefaultChatbotConfigurationForCourse = <ThrowOnError extends boolean = true>(
  options: Options<GetDefaultChatbotConfigurationForCourseData, ThrowOnError>,
): RequestResult<GetDefaultChatbotConfigurationForCourseResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetDefaultChatbotConfigurationForCourseResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetDefaultChatbotConfigurationForCourseResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/default-for-course/{course_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations`
 *
 * Returns a chatbot conversation for the user. If conversation id is not provided as a query parameter then latest conversation is returned.
 */
export const getConversationInfo = <ThrowOnError extends boolean = true>(
  options: Options<GetConversationInfoData, ThrowOnError>,
): RequestResult<GetConversationInfoResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetConversationInfoResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zGetConversationInfoResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/current/id`
 *
 * Returns current chatbot conversation id.
 */
export const getCurrentConversationId = <ThrowOnError extends boolean = true>(
  options: Options<GetCurrentConversationIdData, ThrowOnError>,
): RequestResult<GetCurrentConversationIdResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCurrentConversationIdResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zGetCurrentConversationIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations/current/id",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/course-modules/chatbot/:chatbot_configuration_id/conversations/new`
 *
 * Sends a new chat message to the chatbot.
 */
export const newChatbotConversation = <ThrowOnError extends boolean = true>(
  options: Options<NewChatbotConversationData, ThrowOnError>,
): RequestResult<NewChatbotConversationResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<NewChatbotConversationResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zNewChatbotConversationResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations/new",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/send-message`
 *
 * Sends a new chat message to the chatbot.
 */
export const sendChatbotMessage = <ThrowOnError extends boolean = true>(
  options: Options<SendChatbotMessageData, ThrowOnError>,
): RequestResult<SendChatbotMessageResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<SendChatbotMessageResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zSendChatbotMessageResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations/{conversation_id}/send-message",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * POST `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/tool-response`
 *
 * Answers a tool call the chatbot suspended its turn on, which resumes the turn once nothing else
 * is outstanding. Responds with the same stream `send-message` does, carrying either the resumed
 * turn or a lone `Suspended` event when the turn is still waiting for another answer.
 */
export const sendChatbotToolResponse = <ThrowOnError extends boolean = true>(
  options: Options<SendChatbotToolResponseData, ThrowOnError>,
): RequestResult<SendChatbotToolResponseResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<SendChatbotToolResponseResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zSendChatbotToolResponseResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations/{conversation_id}/tool-response",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * PUT `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/update-title`
 *
 * Updates the title of a chatbot conversation.
 */
export const updateTitle = <ThrowOnError extends boolean = true>(
  options: Options<UpdateTitleData, ThrowOnError>,
): RequestResult<UpdateTitleResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).put<UpdateTitleResponses, unknown, ThrowOnError, "data">({
    responseStyle: "data",
    url: "/api/v0/course-material/chatbot/{chatbot_configuration_id}/conversations/{conversation_id}/update-title",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * POST /api/v0/course-material/code-giveaways/:id/claim - Claim a code from a code giveaway. If user has not completed the course module that is a requirement for the code, returns an error.
 */
export const claimCodeFromCodeGiveaway = <ThrowOnError extends boolean = true>(
  options: Options<ClaimCodeFromCodeGiveawayData, ThrowOnError>,
): RequestResult<ClaimCodeFromCodeGiveawayResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    ClaimCodeFromCodeGiveawayResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zClaimCodeFromCodeGiveawayResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/code-giveaways/{id}/claim",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/code-giveaways/:id/status - Returns information about a code giveaway.
 */
export const getCodeGiveawayStatus = <ThrowOnError extends boolean = true>(
  options: Options<GetCodeGiveawayStatusData, ThrowOnError>,
): RequestResult<GetCodeGiveawayStatusResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCodeGiveawayStatusResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zGetCodeGiveawayStatusResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/code-giveaways/{id}/status",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/course-instance/:course_instance_id/background-questions-and-answers - Gets background questions and answers for an course instance.
 */
export const getCourseMaterialBackgroundQuestionsAndAnswers = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialBackgroundQuestionsAndAnswersData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialBackgroundQuestionsAndAnswersResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialBackgroundQuestionsAndAnswersResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialBackgroundQuestionsAndAnswersResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/background-questions-and-answers",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/course-instance/:course_instance_id/chapters/:chapter_id/exercises/progress - Returns user progress for an exercise in given course instance.
 */
export const getCourseMaterialChapterExerciseProgress = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterExerciseProgressData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialChapterExerciseProgressResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterExerciseProgressResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterExerciseProgressResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/chapters/{chapter_id}/exercises/progress",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-instance/:course_instance_id/chapters/:chapter_id/progress - Returns user progress for chapter in course instance.
 */
export const getCourseMaterialChapterProgress = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterProgressData, ThrowOnError>,
): RequestResult<GetCourseMaterialChapterProgressResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterProgressResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterProgressResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/chapters/{chapter_id}/progress",
    ...options,
  })

/**
 *
 * GET /course-instances/:id/course-module-completions/:user_id - Returns a list of all course module completions for a given user for this course instance.
 */
export const getCourseMaterialCourseModuleCompletionsForUser = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialCourseModuleCompletionsForUserData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialCourseModuleCompletionsForUserResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialCourseModuleCompletionsForUserResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCourseModuleCompletionsForUserResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/course-module-completions/{user_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-instances/:course_instance_id/course-modules/:course_module_id/points-breakdown` - Returns the user's points in the module's opened chapters, exercise by exercise.
 */
export const getCourseMaterialCourseModulePointsBreakdown = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialCourseModulePointsBreakdownData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialCourseModulePointsBreakdownResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialCourseModulePointsBreakdownResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCourseModulePointsBreakdownResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/course-modules/{course_module_id}/points-breakdown",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-instance/{course_instance_id}/module-completions`
 */
export const getCourseMaterialUserModuleCompletions = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialUserModuleCompletionsData, ThrowOnError>,
): RequestResult<GetCourseMaterialUserModuleCompletionsResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialUserModuleCompletionsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialUserModuleCompletionsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/module-completions",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/course-instance/:course_intance_id/progress - returns user progress information.
 */
export const getCourseMaterialUserCourseProgress = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialUserCourseProgressData, ThrowOnError>,
): RequestResult<GetCourseMaterialUserCourseProgressResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialUserCourseProgressResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialUserCourseProgressResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/progress",
    ...options,
  })

/**
 *
 * POST /api/v0/course-material/course-instance/:course_instance_id/save-course-settings - enrolls user to the course instance and save background questions.
 */
export const saveCourseMaterialCourseSettings = <ThrowOnError extends boolean = true>(
  options: Options<SaveCourseMaterialCourseSettingsData, ThrowOnError>,
): RequestResult<SaveCourseMaterialCourseSettingsResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    SaveCourseMaterialCourseSettingsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zSaveCourseMaterialCourseSettingsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-instances/{course_instance_id}/save-course-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/course-modules/chapter/:chapter_id`
 *
 * Returns course module id based on chapter.
 */
export const getCourseMaterialModuleIdByChapterId = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialModuleIdByChapterIdData, ThrowOnError>,
): RequestResult<GetCourseMaterialModuleIdByChapterIdResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialModuleIdByChapterIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialModuleIdByChapterIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-modules/chapter/{chapter_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-modules/course/:course_instance_id`
 *
 * Returns course module id based on chapter.
 */
export const getCourseMaterialDefaultModuleIdByCourseId = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialDefaultModuleIdByCourseIdData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialDefaultModuleIdByCourseIdResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialDefaultModuleIdByCourseIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialDefaultModuleIdByCourseIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-modules/course/{course_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/course-modules/:course_module_id/exercise-tasks/:exercise_type/:course_instance_id`
 *
 * Returns exercise submissions for user to be used in en exercise service Custom view.
 */
export const getCourseMaterialExerciseTasksByModuleAndType = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialExerciseTasksByModuleAndTypeData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialExerciseTasksByModuleAndTypeResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialExerciseTasksByModuleAndTypeResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialExerciseTasksByModuleAndTypeResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/course-modules/{course_module_id}/exercise-tasks/{exercise_type}/{course_instance_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id` - Get course.
 */
export const getCourseMaterialCourse = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialCourseData, ThrowOnError>,
): RequestResult<GetCourseMaterialCourseResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCourseMaterialCourseResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zGetCourseMaterialCourseResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/ai-usage-notice-acknowledgement` - Whether the
 * current user has acknowledged the AI-usage / academic-integrity notice for this course.
 */
export const getAiUsageNoticeAcknowledgement = <ThrowOnError extends boolean = true>(
  options: Options<GetAiUsageNoticeAcknowledgementData, ThrowOnError>,
): RequestResult<GetAiUsageNoticeAcknowledgementResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetAiUsageNoticeAcknowledgementResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetAiUsageNoticeAcknowledgementResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/ai-usage-notice-acknowledgement",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/ai-usage-notice-acknowledgement` - Records that
 * the current user has acknowledged the AI-usage / academic-integrity notice for this course.
 */
export const acknowledgeAiUsageNotice = <ThrowOnError extends boolean = true>(
  options: Options<AcknowledgeAiUsageNoticeData, ThrowOnError>,
): RequestResult<AcknowledgeAiUsageNoticeResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<AcknowledgeAiUsageNoticeResponses, unknown, ThrowOnError, "data">(
    {
      responseValidator: async (data) => await zAcknowledgeAiUsageNoticeResponse.parseAsync(data),
      responseStyle: "data",
      url: "/api/v0/course-material/courses/{course_id}/ai-usage-notice-acknowledgement",
      ...options,
    },
  )

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/chapters` - Returns a list of chapters in a course.
 */
export const getCourseMaterialChapters = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChaptersData, ThrowOnError>,
): RequestResult<GetCourseMaterialChaptersResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCourseMaterialChaptersResponses, unknown, ThrowOnError, "data">(
    {
      responseValidator: async (data) => await zGetCourseMaterialChaptersResponse.parseAsync(data),
      responseStyle: "data",
      url: "/api/v0/course-material/courses/{course_id}/chapters",
      ...options,
    },
  )

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/course-instances` - Returns all course instances for given course id.
 */
export const getCourseMaterialCourseInstances = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialCourseInstancesData, ThrowOnError>,
): RequestResult<GetCourseMaterialCourseInstancesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialCourseInstancesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCourseInstancesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/course-instances",
    ...options,
  })

/**
 *
 * GET `/api/v0/{course_id}/course-instances/{course_instance_id}/student-countries - Returns countries of student registered in a course.
 */
export const getCourseMaterialStudentCountries = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialStudentCountriesData, ThrowOnError>,
): RequestResult<GetCourseMaterialStudentCountriesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialStudentCountriesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialStudentCountriesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/course-instances/{course_instance_id}/student-countries",
    ...options,
  })

/**
 *
 * POST `/api/v0/{course_id}/course-instances/{course_instance_id}/student-countries/{country_code}` - Add a new student's country entry.
 */
export const postCourseMaterialStudentCountry = <ThrowOnError extends boolean = true>(
  options: Options<PostCourseMaterialStudentCountryData, ThrowOnError>,
): RequestResult<PostCourseMaterialStudentCountryResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostCourseMaterialStudentCountryResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zPostCourseMaterialStudentCountryResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/course-instances/{course_instance_id}/student-countries/{country_code}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/current-instance` - Returns the instance of a course for the current user, if there is one.
 */
export const getCurrentCourseMaterialCourseInstance = <ThrowOnError extends boolean = true>(
  options: Options<GetCurrentCourseMaterialCourseInstanceData, ThrowOnError>,
): RequestResult<GetCurrentCourseMaterialCourseInstanceResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCurrentCourseMaterialCourseInstanceResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCurrentCourseMaterialCourseInstanceResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/current-instance",
    ...options,
  })

/**
 *
 * GET /courses/:course_id/custom-privacy-policy-checkbox-texts - Used to get customized checkbox texts for courses that use a different privacy policy than all our other courses (e.g. the Elements of AI course). These texts are shown in the course settings dialog.
 */
export const getCourseMaterialCustomPrivacyPolicyCheckboxTexts = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialCustomPrivacyPolicyCheckboxTextsData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/custom-privacy-policy-checkbox-texts",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/feedback` - Creates new feedback.
 */
export const postFeedback = <ThrowOnError extends boolean = true>(
  options: Options<PostFeedbackData, ThrowOnError>,
): RequestResult<PostFeedbackResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<PostFeedbackResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zPostFeedbackResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/fetch-user-marketing-consent`
 */
export const getCourseMaterialUserMarketingConsent = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialUserMarketingConsentData, ThrowOnError>,
): RequestResult<GetCourseMaterialUserMarketingConsentResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialUserMarketingConsentResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialUserMarketingConsentResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/fetch-user-marketing-consent",
    ...options,
  })

export const getCourseMaterialGlossary = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialGlossaryData, ThrowOnError>,
): RequestResult<GetCourseMaterialGlossaryResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCourseMaterialGlossaryResponses, unknown, ThrowOnError, "data">(
    {
      responseValidator: async (data) => await zGetCourseMaterialGlossaryResponse.parseAsync(data),
      responseStyle: "data",
      url: "/api/v0/course-material/courses/{course_id}/glossary",
      ...options,
    },
  )

/**
 *
 * GET `/api/v0/course-material/courses/:id/language-versions-navigation-info/from-page/:page_id` - Returns all language versions of the same course. Since this is for course material, this does not include draft courses. To make developing new courses easier, we include all draft courses that the user has access to.
 */
export const getCourseMaterialLanguageVersionNavigationInfos = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialLanguageVersionNavigationInfosData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialLanguageVersionNavigationInfosResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialLanguageVersionNavigationInfosResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialLanguageVersionNavigationInfosResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/language-versions-navigation-info/from-page/{page_id}",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/pages` - Returns a list of public pages on a course.
 *
 * Since anyone can access this endpoint, any unlisted pages are omited from these results.
 */
export const getCourseMaterialCoursePages = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialCoursePagesData, ThrowOnError>,
): RequestResult<GetCourseMaterialCoursePagesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialCoursePagesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zGetCourseMaterialCoursePagesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/pages",
    ...options,
  })

/**
 *
 * GET `/api/v0/{course_id}/pages/by-language-group-id/{page_language_group_id} - Returns a page with the given course id and language group id.
 */
export const getCourseMaterialPageByCourseIdAndLanguageGroupId = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialPageByCourseIdAndLanguageGroupIdData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPageByCourseIdAndLanguageGroupIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/pages/by-language-group-id/{page_language_group_id}",
    ...options,
  })

/**
 *
 * GET /courses/:course_id/partners-block - Gets a partners block related to a course
 */
export const getCourseMaterialPartnersBlock = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPartnersBlockData, ThrowOnError>,
): RequestResult<GetCourseMaterialPartnersBlockResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPartnersBlockResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPartnersBlockResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/partners-block",
    ...options,
  })

/**
 *
 * GET /courses/:course_id/privacy_link - Gets a privacy link related to a course
 */
export const getCourseMaterialPrivacyLink = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPrivacyLinkData, ThrowOnError>,
): RequestResult<GetCourseMaterialPrivacyLinkResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPrivacyLinkResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zGetCourseMaterialPrivacyLinkResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/privacy-link",
    ...options,
  })

export const getCourseMaterialReferences = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialReferencesData, ThrowOnError>,
): RequestResult<GetCourseMaterialReferencesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialReferencesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zGetCourseMaterialReferencesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/references",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/research-consent-form` - Fetches courses research form with course id.
 */
export const getCourseMaterialResearchConsentForm = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialResearchConsentFormData, ThrowOnError>,
): RequestResult<GetCourseMaterialResearchConsentFormResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialResearchConsentFormResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialResearchConsentFormResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/research-consent-form",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/research-consent-form-questions` - Fetches courses research form questions with course id.
 */
export const getCourseMaterialResearchConsentFormQuestions = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialResearchConsentFormQuestionsData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialResearchConsentFormQuestionsResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialResearchConsentFormQuestionsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialResearchConsentFormQuestionsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/research-consent-form-questions",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/research-consent-form-questions-answer` - Upserts users consent for a courses research form question.
 */
export const postCourseMaterialResearchConsentFormAnswer = <ThrowOnError extends boolean = true>(
  options: Options<PostCourseMaterialResearchConsentFormAnswerData, ThrowOnError>,
): RequestResult<
  PostCourseMaterialResearchConsentFormAnswerResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).post<
    PostCourseMaterialResearchConsentFormAnswerResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zPostCourseMaterialResearchConsentFormAnswerResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/research-consent-form-questions-answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course/courses/:course_id/research-consent-form-users-answers` - Fetches users answers for courses research form.
 */
export const getCourseMaterialResearchConsentFormAnswers = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialResearchConsentFormAnswersData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialResearchConsentFormAnswersResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialResearchConsentFormAnswersResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialResearchConsentFormAnswersResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/research-consent-form-user-answers",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/search-pages-with-phrase` - Returns a list of pages given a search query.
 *
 * Provided words are supposed to appear right after each other in the source document.
 *
 * # Example
 *
 * Request:
 *
 * ```http
 * POST /api/v0/course-material/courses/1a68e8b0-d151-4c0e-9307-bb154e9d2be1/search-pages-with-phrase HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "query": "Everything"
 * }
 * ```
 */
export const searchPagesWithPhrase = <ThrowOnError extends boolean = true>(
  options: Options<SearchPagesWithPhraseData, ThrowOnError>,
): RequestResult<SearchPagesWithPhraseResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<SearchPagesWithPhraseResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zSearchPagesWithPhraseResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/search-pages-with-phrase",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/search-pages-with-words` - Returns a list of pages given a search query.
 *
 * Provided words can appear in any order in the source document.
 *
 * # Example
 *
 * Request:
 *
 * ```http
 * POST /api/v0/course-material/courses/1a68e8b0-d151-4c0e-9307-bb154e9d2be1/search-pages-with-words HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "query": "Everything"
 * }
 * ```
 */
export const searchPagesWithWords = <ThrowOnError extends boolean = true>(
  options: Options<SearchPagesWithWordsData, ThrowOnError>,
): RequestResult<SearchPagesWithWordsResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<SearchPagesWithWordsResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zSearchPagesWithWordsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/search-pages-with-words",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET /api/v0/course-material/courses/:course_id/top-level-pages
 */
export const getCourseMaterialTopLevelPages = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialTopLevelPagesData, ThrowOnError>,
): RequestResult<GetCourseMaterialTopLevelPagesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialTopLevelPagesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialTopLevelPagesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/top-level-pages",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/user-chapter-locks` - Get user's chapter locking statuses for course
 *
 * Returns all chapters that the authenticated user has unlocked or completed for the specified course.
 * *
 */
export const getCourseMaterialUserChapterLocks = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialUserChapterLocksData, ThrowOnError>,
): RequestResult<GetCourseMaterialUserChapterLocksResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialUserChapterLocksResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialUserChapterLocksResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/user-chapter-locks",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/user-marketing-consent` - Adds or updates user's marketing consent for a specific course.
 */
export const updateMarketingConsent = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMarketingConsentData, ThrowOnError>,
): RequestResult<UpdateMarketingConsentResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<UpdateMarketingConsentResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zUpdateMarketingConsentResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/user-marketing-consent",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/user-settings` - Returns user settings for the current course.
 */
export const getCourseMaterialUserCourseSettings = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialUserCourseSettingsData, ThrowOnError>,
): RequestResult<GetCourseMaterialUserCourseSettingsResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialUserCourseSettingsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialUserCourseSettingsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_id}/user-settings",
    ...options,
  })

/**
 *
 * GET `/api/v0/{course_id}/student-country - Returns country of a student registered in a course.
 */
export const getCourseMaterialStudentCountry = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialStudentCountryData, ThrowOnError>,
): RequestResult<GetCourseMaterialStudentCountryResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialStudentCountryResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialStudentCountryResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_instance_id}/student-country",
    ...options,
  })

/**
 *
 * GET `/:course_slug/page-by-path/...` - Returns a course page by path
 *
 * If the page has moved and there's a redirection, this will still return the moved page but the field `was_redirected` will indicate that the redirection happened. The new path can be found in the page object. The frontend is supposed to update the url of the page to the new location without reloading the page.
 *
 * # Example
 * GET /api/v0/course-material/courses/introduction-to-everything/page-by-path//part-2/hello-world
 */
export const getCourseMaterialCoursePageByPath = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialCoursePageByPathData, ThrowOnError>,
): RequestResult<GetCourseMaterialCoursePageByPathResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialCoursePageByPathResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCoursePageByPathResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_slug}/page-by-path/{url_path}",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_slug/edit` - Creates a new edit proposal.
 */
export const postCourseMaterialCourseEditProposal = <ThrowOnError extends boolean = true>(
  options: Options<PostCourseMaterialCourseEditProposalData, ThrowOnError>,
): RequestResult<PostCourseMaterialCourseEditProposalResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostCourseMaterialCourseEditProposalResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zPostCourseMaterialCourseEditProposalResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/courses/{course_slug}/propose-edit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET /api/v0/course-material/exams/:id/fetch-exam-for-testing
 *
 * Fetches an exam for testing.
 */
export const fetchExamForTesting = <ThrowOnError extends boolean = true>(
  options: Options<FetchExamForTestingData, ThrowOnError>,
): RequestResult<FetchExamForTestingResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<FetchExamForTestingResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zFetchExamForTestingResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exams/testexam/{id}/fetch-exam-for-testing",
    ...options,
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/reset-exam-progress
 *
 * Used for testing an exam, resets exercise submissions and restarts the exam time.
 */
export const resetExamProgress = <ThrowOnError extends boolean = true>(
  options: Options<ResetExamProgressData, ThrowOnError>,
): RequestResult<ResetExamProgressResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<ResetExamProgressResponses, unknown, ThrowOnError, "data">({
    responseStyle: "data",
    url: "/api/v0/course-material/exams/testexam/{id}/reset-exam-progress",
    ...options,
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/update-show-exercise-answers
 *
 * Used for testing an exam, updates wheter exercise answers are shown.
 */
export const updateShowExerciseAnswers = <ThrowOnError extends boolean = true>(
  options: Options<UpdateShowExerciseAnswersData, ThrowOnError>,
): RequestResult<UpdateShowExerciseAnswersResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    UpdateShowExerciseAnswersResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseStyle: "data",
    url: "/api/v0/course-material/exams/testexam/{id}/update-show-exercise-answers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET /api/v0/course-material/exams/:id
 */
export const fetchExam = <ThrowOnError extends boolean = true>(
  options: Options<FetchExamData, ThrowOnError>,
): RequestResult<FetchExamResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<FetchExamResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zFetchExamResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exams/{id}",
    ...options,
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/end-exam-time
 *
 * Used for marking the students exam as ended in the exam enrollment
 */
export const endExamTime = <ThrowOnError extends boolean = true>(
  options: Options<EndExamTimeData, ThrowOnError>,
): RequestResult<EndExamTimeResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<EndExamTimeResponses, unknown, ThrowOnError, "data">({
    responseStyle: "data",
    url: "/api/v0/course-material/exams/{id}/end-exam-time",
    ...options,
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/enroll
 */
export const enrollInExam = <ThrowOnError extends boolean = true>(
  options: Options<EnrollInExamData, ThrowOnError>,
): RequestResult<EnrollInExamResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<EnrollInExamResponses, unknown, ThrowOnError, "data">({
    responseStyle: "data",
    url: "/api/v0/course-material/exams/{id}/enroll",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET /api/v0/course-material/exams/:id/enrollment
 */
export const fetchExamEnrollment = <ThrowOnError extends boolean = true>(
  options: Options<FetchExamEnrollmentData, ThrowOnError>,
): RequestResult<FetchExamEnrollmentResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<FetchExamEnrollmentResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zFetchExamEnrollmentResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exams/{id}/enrollment",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id` - Get exercise by id. Includes
 * relevant context so that doing the exercise is possible based on the response.
 *
 * This endpoint does not expose exercise's private spec because it would
 * expose the correct answers to the user.
 */
export const getCourseMaterialExercise = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialExerciseData, ThrowOnError>,
): RequestResult<GetCourseMaterialExerciseResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<GetCourseMaterialExerciseResponses, unknown, ThrowOnError, "data">(
    {
      responseValidator: async (data) => await zGetCourseMaterialExerciseResponse.parseAsync(data),
      responseStyle: "data",
      url: "/api/v0/course-material/exercises/{exercise_id}",
      ...options,
    },
  )

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id/peer-review-received` - Get peer review recieved from other student for an exercise. This includes peer review submitted and the question asociated with it.
 */
export const fetchPeerReviewDataReceivedByExerciseId = <ThrowOnError extends boolean = true>(
  options: Options<FetchPeerReviewDataReceivedByExerciseIdData, ThrowOnError>,
): RequestResult<FetchPeerReviewDataReceivedByExerciseIdResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    FetchPeerReviewDataReceivedByExerciseIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zFetchPeerReviewDataReceivedByExerciseIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/exercise-slide-submission/{exercise_slide_submission_id}/peer-or-self-reviews-received",
    ...options,
  })

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/flag-peer-review-answer - Post a report of an answer in peer review made by a student
 */
export const postFlagAnswerInPeerReview = <ThrowOnError extends boolean = true>(
  options: Options<PostFlagAnswerInPeerReviewData, ThrowOnError>,
): RequestResult<PostFlagAnswerInPeerReviewResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostFlagAnswerInPeerReviewResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zPostFlagAnswerInPeerReviewResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/flag-peer-review-answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/peer-or-self-reviews - Post a peer review or a self review for an
 * * exercise submission.
 */
export const postPeerOrSelfReviewSubmission = <ThrowOnError extends boolean = true>(
  options: Options<PostPeerOrSelfReviewSubmissionData, ThrowOnError>,
): RequestResult<PostPeerOrSelfReviewSubmissionResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostPeerOrSelfReviewSubmissionResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zPostPeerOrSelfReviewSubmissionResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/peer-or-self-reviews",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/peer-or-self-reviews/start` - Post a signal indicating that
 * * the user will start the peer or self reviewing process.
 * *
 * * This operation is only valid for exercises marked for peer reviews. No further submissions will be
 * * accepted after posting to this endpoint.
 */
export const postStartPeerOrSelfReview = <ThrowOnError extends boolean = true>(
  options: Options<PostStartPeerOrSelfReviewData, ThrowOnError>,
): RequestResult<PostStartPeerOrSelfReviewResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostStartPeerOrSelfReviewResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zPostStartPeerOrSelfReviewResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/peer-or-self-reviews/start",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id/peer-review` - Get peer review for an exercise. This includes the submission to peer review and the questions the user is supposed to answer.ALTER
 *
 * This request will fail if the user is not in the peer review stage yet because the information included in the peer review often exposes the correct solution to the exercise.
 */
export const fetchPeerOrSelfReviewDataByExerciseId = <ThrowOnError extends boolean = true>(
  options: Options<FetchPeerOrSelfReviewDataByExerciseIdData, ThrowOnError>,
): RequestResult<FetchPeerOrSelfReviewDataByExerciseIdResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    FetchPeerOrSelfReviewDataByExerciseIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zFetchPeerOrSelfReviewDataByExerciseIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/peer-review",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/exercises/:exercise_id/submissions` - Post new submission for an
 * exercise.
 *
 * # Example
 * ```http
 * POST /api/v0/course-material/exercises/:exercise_id/submissions HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "exercise_slide_id": "0125c21b-6afa-4652-89f7-56c48bd8ffe4",
 * "exercise_task_answers": [
 * {
 * "exercise_task_id": "0125c21b-6afa-4652-89f7-56c48bd8ffe4",
 * "answer": {
 * "kind": "json",
 * "data": { "selectedOptionId": "8f09e9a0-ac20-486a-ba29-704e7eeaf6af" }
 * }
 * }
 * ]
 * }
 * ```
 */
export const postSubmission = <ThrowOnError extends boolean = true>(
  options: Options<PostSubmissionData, ThrowOnError>,
): RequestResult<PostSubmissionResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<PostSubmissionResponses, unknown, ThrowOnError, "data">({
    responseValidator: async (data) => await zPostSubmissionResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/exercises/{exercise_id}/submissions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/oembed/mentimeter?url=https://menti.com/123qwerty`
 */
export const getCourseMaterialMentimeterOembed = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialMentimeterOembedData, ThrowOnError>,
): RequestResult<GetCourseMaterialMentimeterOembedResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialMentimeterOembedResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialMentimeterOembedResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/oembed/mentimeter",
    ...options,
  })

/**
 *
 * GET /organizations/:organization_id - Get organization.
 */
export const getCourseMaterialOrganization = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialOrganizationData, ThrowOnError>,
): RequestResult<GetCourseMaterialOrganizationResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialOrganizationResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialOrganizationResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/organizations/{organization_id}",
    ...options,
  })

export const getCourseMaterialPageAudioFiles = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPageAudioFilesData, ThrowOnError>,
): RequestResult<GetCourseMaterialPageAudioFilesResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPageAudioFilesResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPageAudioFilesResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/page_audio/{page_id}/files",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/pages/exam/{page_id}
 */
export const getCourseMaterialPageByExamId = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPageByExamIdData, ThrowOnError>,
): RequestResult<GetCourseMaterialPageByExamIdResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPageByExamIdResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPageByExamIdResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/exam/{page_id}",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/pages/:page_id/chapter-and-course-information - gives the page's chapter and course information -- useful for the breadcrumbs
 */
export const getCourseMaterialPageChapterAndCourseInformation = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetCourseMaterialPageChapterAndCourseInformationData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialPageChapterAndCourseInformationResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options.client ?? client).get<
    GetCourseMaterialPageChapterAndCourseInformationResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPageChapterAndCourseInformationResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/{current_page_id}/chapter-and-course-information",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/page/{page_id}
 */
export const getCourseMaterialChapterFrontPage = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialChapterFrontPageData, ThrowOnError>,
): RequestResult<GetCourseMaterialChapterFrontPageResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialChapterFrontPageResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialChapterFrontPageResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/{current_page_id}/chapter-front-page",
    ...options,
  })

export const getCourseMaterialIsPageChapterFrontPage = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialIsPageChapterFrontPageData, ThrowOnError>,
): RequestResult<GetCourseMaterialIsPageChapterFrontPageResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialIsPageChapterFrontPageResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialIsPageChapterFrontPageResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/{current_page_id}/is-chapter-front-page",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/pages/:page_id/page-navigation - tells what's the next page, previous page, and the chapter front page given a page id.
 */
export const getCourseMaterialPageNavigation = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPageNavigationData, ThrowOnError>,
): RequestResult<GetCourseMaterialPageNavigationResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPageNavigationResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialPageNavigationResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/{current_page_id}/page-navigation",
    ...options,
  })

/**
 *
 * GET /api/v0/course-material/pages/:page_id/url-path - returns the page's URL path.
 * # Example
 * ```json
 * "chapter-1/page-2"
 * ```
 */
export const getCourseMaterialPageUrlPath = <ThrowOnError extends boolean = true>(
  options: Options<GetCourseMaterialPageUrlPathData, ThrowOnError>,
): RequestResult<GetCourseMaterialPageUrlPathResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).get<
    GetCourseMaterialPageUrlPathResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zGetCourseMaterialPageUrlPathResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/pages/{current_page_id}/url-path",
    ...options,
  })

/**
 *
 * POST `/api/v0/course-material/proposed-edits/:course-id`
 */
export const postCourseMaterialProposedEdits = <ThrowOnError extends boolean = true>(
  options: Options<PostCourseMaterialProposedEditsData, ThrowOnError>,
): RequestResult<PostCourseMaterialProposedEditsResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    PostCourseMaterialProposedEditsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseStyle: "data",
    url: "/api/v0/course-material/proposed-edits/{course_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * POST `/api/v0/course-material/user-details/update-user-info` - Updates the users information such as email, name, country and email communication consent
 */
export const updateCourseMaterialUserInfo = <ThrowOnError extends boolean = true>(
  options: Options<UpdateCourseMaterialUserInfoData, ThrowOnError>,
): RequestResult<UpdateCourseMaterialUserInfoResponses, unknown, ThrowOnError, "data"> =>
  (options.client ?? client).post<
    UpdateCourseMaterialUserInfoResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) => await zUpdateCourseMaterialUserInfoResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/user-details/update-user-info",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 *
 * GET `/api/v0/course-material/user-details/user` - Find user details by user id
 */
export const getCourseMaterialAuthenticatedUserDetails = <ThrowOnError extends boolean = true>(
  options?: Options<GetCourseMaterialAuthenticatedUserDetailsData, ThrowOnError>,
): RequestResult<
  GetCourseMaterialAuthenticatedUserDetailsResponses,
  unknown,
  ThrowOnError,
  "data"
> =>
  (options?.client ?? client).get<
    GetCourseMaterialAuthenticatedUserDetailsResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialAuthenticatedUserDetailsResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/user-details/user",
    ...options,
  })

/**
 *
 * GET `/api/v0/course-material/user-details/users-ip-country` - Find users country by their IP  address
 */
export const getCourseMaterialCountryFromIp = <ThrowOnError extends boolean = true>(
  options?: Options<GetCourseMaterialCountryFromIpData, ThrowOnError>,
): RequestResult<GetCourseMaterialCountryFromIpResponses, unknown, ThrowOnError, "data"> =>
  (options?.client ?? client).get<
    GetCourseMaterialCountryFromIpResponses,
    unknown,
    ThrowOnError,
    "data"
  >({
    responseValidator: async (data) =>
      await zGetCourseMaterialCountryFromIpResponse.parseAsync(data),
    responseStyle: "data",
    url: "/api/v0/course-material/user-details/users-ip-country",
    ...options,
  })
